window.SMTX.GlobalAlerts = (function () {

  if ($('#global_alerts').length < 0) {
    return false;
  }

  // var $_globalAlerts = $('#global_alerts');
  // var _alertDismissedValue = 'alertDismissed';

  // $_globalAlerts.find('.callout').each(function () {
  //   var $me = $(this);

  //   if (getCookie($me.data('id')) === null) {
  //     $me.removeClass('hide');
  //   }
  // });

  $(document).on('click', "#global_alerts [data-close]", function () {
    //log('click');
    //log($(this).data('callout-id'));
    var alertId = $(this).data('callout-id');
    setCookie(alertId, _alertDismissedValue, 0);
  });


  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";path=/";
  }

  // function getCookie(cname) {
  //   var name = cname + "=";
  //   var ca = document.cookie.split(';');
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i];
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1);
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length);
  //     }
  //   }
  //   return null;
  // }

  return {

  };

})();
